export enum ESelectedKpiType {
  PPE = 'PEP',
  LVET = 'LVET',
  IVCT = 'IVCT',
}
